import { TextField } from '@material-ui/core';
import { Input } from 'reactstrap';
import './index.scss'

const InputCommon = (props) => {
	return (
        // <Input {...props} />
		<TextField fullWidth {...props}/>
	)
}

export default InputCommon;